import React, { useEffect, useState } from 'react';
import AddOfficeLocationComponent from './AddOfficeLocationComponent';
import OfficeLocationCardComponent from './OfficeLocationCardComponent';
import HttpService from '../../../../services/HttpService';
import { ADMIN_PATH } from '../../../../url';
import { Grid, Typography } from '@mui/material';
import ErrorSwitchCase from '../../../../services/ErrorHandlerService';

const OfficeLocation = (props) => {
  const [officeLocation, setOfficeLocation] = useState([]);
  const [office, setOffice] = useState({
    id: '',
    locationName: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    officeType: '',
    openingDate: new Date(),
  });
  const [currentOfficeId, setCurrentOfficeId] = useState(null);
  const [expanded, setExpanded] = React.useState(false);
  const [editable, setEditable] = React.useState(false);

  const _axios = HttpService.getAxiosClient();

  const fetchOfficeLocation = async () => {
    setOfficeLocation([]);
    try {
      const response = await _axios.get(`${ADMIN_PATH}/office-location`);
      if (response.status === 200) setOfficeLocation(response.data.data);
    } catch (error) {
      console.error('Error fetching office location:', error);
    }
  };

  const getOfficeLocationById = async (id) => {
    const toEditOffice = await getOfficeById(id);
    setOffice({
      id: toEditOffice.data.data[0].id,
      locationName: toEditOffice.data.data[0].locationName,
      address: toEditOffice.data.data[0].address,
      city: toEditOffice.data.data[0].city,
      state: toEditOffice.data.data[0].state,
      country: toEditOffice.data.data[0].country,
      postalCode: toEditOffice.data.data[0].postalCode,
      officeType: toEditOffice.data.data[0].officeType,
      openingDate: new Date(toEditOffice.data.data[0].openingDate),
    });
    setCurrentOfficeId(toEditOffice.data.data[0].id);
    setEditable(true);
  };

  const getOfficeById = async (locationId) => {
    try {
      const response = await _axios.get(`${ADMIN_PATH}/office-location`, {
        params: { locationId: locationId },
      });
      return ErrorSwitchCase(response);
    } catch (error) {
      return ErrorSwitchCase(error.response?.data);
    }
  };

  const resetOffice = () => {
    setOffice({
      id: '',
      locationName: '',
      address: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
      officeType: '',
      openingDate: new Date(),
    });
  };

  useEffect(() => {
    fetchOfficeLocation();
  }, []);
  return (
    <div>
      <AddOfficeLocationComponent
        loadData={fetchOfficeLocation}
        office={office}
        expanded={expanded}
        setExpanded={setExpanded}
        editable={editable}
        setEditable={setEditable}
        resetOffice={resetOffice}
      />
      {officeLocation.length !== 0 ? (
        officeLocation.map((office, index) => {
          return (
            <OfficeLocationCardComponent
              key={office.id}
              office={office}
              currentOfficeId={currentOfficeId}
              getOfficeLocationById={getOfficeLocationById}
              setExpanded={setExpanded}
              expanded={expanded}
              loadData={fetchOfficeLocation}
            />
          );
        })
      ) : (
        <Grid container item md={3} xs={3} sx={{ height: '350px', m: 'auto' }}>
          <Typography sx={{ mt: 'auto', mb: 'auto' }}>
            No Office Locations
          </Typography>
        </Grid>
      )}
    </div>
  );
};

export default OfficeLocation;
